// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 1237 ? "BaseComponent" : chunkId) + "." + {"1237":"fab1f7fb","2126":"75b38058","3206":"85ffcbf3","7358":"972158b5","7821":"922f7882","7915":"35a17bff","8976":"b0c52de9"}[chunkId] + ".css";
};